import type { BrandConfigPos } from '@t-soft-io/retail-shared/api/models'
import { createBrandConfigStore, type PublishedConfig } from '@t-soft-io/retail-shared/brand'
import { mqttConfig, platformEnvironment } from '@t-soft-io/retail-shared/platform'
import { clearBrandSession } from '../utils/brandSession'
import { fetchImageDataUri } from './fetchImageDataUri'
import { DomainConfig } from './types'

const fromPublished = (cfg: PublishedConfig<BrandConfigPos>): DomainConfig => ({
  API_BASE_URL: cfg.api.baseUrl,
  ...mqttConfig(platformEnvironment(window.location.hostname)),
  APP_KEY: cfg.appKey,
  CLIENT_ID: cfg.clientId,
  BRAND_NAME: cfg.brand.name,
  BRAND_MARKET: cfg.brand.market ?? undefined,
  LOGO_SRC: cfg.branding?.logo?.src,
  RECEIPT_LOGO_URL: cfg.receiptLogo
})

const store = createBrandConfigStore<BrandConfigPos, DomainConfig>({
  app: 'pos',
  fromPublished,
  onBrandChange: clearBrandSession
})

// Filled in place by loadAppConfiguration, so earlier imports see the loaded values.
export const APP_CONFIGURATION = {} as DomainConfig

export const loadAppConfiguration = async (): Promise<DomainConfig> => {
  const resolved = { ...(await store.load()) }
  if (resolved.RECEIPT_LOGO_URL) {
    resolved.RECEIPT_LOGO = await fetchImageDataUri(resolved.RECEIPT_LOGO_URL)
  }
  for (const key of Object.keys(APP_CONFIGURATION)) {
    delete APP_CONFIGURATION[key as keyof DomainConfig]
  }
  return Object.assign(APP_CONFIGURATION, resolved)
}

export const getSharedBrands = store.sharedBrands
